import { render, staticRenderFns } from "./DrivingLicenseCreate.vue?vue&type=template&id=7dda6c52&"
import script from "./DrivingLicenseCreate.vue?vue&type=script&lang=js&"
export * from "./DrivingLicenseCreate.vue?vue&type=script&lang=js&"
import style0 from "./DrivingLicenseCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports